// Note: if changing the case of statuses, fix the comparison in OrderStatusViewModel

import { getMatFormFieldPlaceholderConflictError } from "@angular/material/form-field"

export enum OrderStatus {
	// NOTE!! These string values are what the API uses, and terminology may be different in UI.

	// Order-level status flags
	Offer = "OFFER",
	Cancelled = "CANCELLED",
	Produced = "PRODUCED",

	// Ad detail-level status counts
	ApprovalPending = "APPROVAL_PENDING",
	Approved = "APPROVED",
	Confirmed = "CONFIRMED",
	Rejected = "REJECTED",
	PastConfirmDeadline = "PAST_CONFIRM_DEADLINE",
	ConfirmDeadlineApproaching = "CONFIRM_DEADLINE_APPROACHING"

}